/**
 * Dyberry Infinite Scroll
 * Adds infinite scroll to the homepage product list section.
 * Uses Shopify Section Rendering API to fetch additional pages.
 */
(function () {
  var container = document.getElementById('dyberry-infinite-scroll');
  if (!container) return;

  var sectionId = container.dataset.sectionId;
  var currentPage = parseInt(container.dataset.currentPage, 10);
  var totalPages = parseInt(container.dataset.totalPages, 10);
  var sentinel = document.getElementById('dyberry-scroll-sentinel');
  var loading = document.getElementById('dyberry-scroll-loading');

  var section = container.closest('[data-testid="product-list"]');
  var grid = section
    ? section.querySelector('[data-testid="resource-list-grid"]')
    : null;

  if (!grid || !sentinel || currentPage >= totalPages) {
    if (container) container.style.display = 'none';
    return;
  }

  var isLoading = false;

  var observer = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting && !isLoading && currentPage < totalPages) {
        loadNextPage();
      }
    },
    { rootMargin: '600px' }
  );

  observer.observe(sentinel);

  function loadNextPage() {
    isLoading = true;
    loading.style.display = 'flex';
    currentPage++;

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', currentPage.toString());

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('Fetch failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fetchedGrid = doc.querySelector(
          '[data-testid="resource-list-grid"]'
        );
        var newItems = fetchedGrid
          ? fetchedGrid.querySelectorAll('.resource-list__item')
          : [];

        if (newItems.length === 0) {
          observer.disconnect();
          container.remove();
          return;
        }

        newItems.forEach(function (item) {
          grid.appendChild(item);
        });

        loading.style.display = 'none';
        isLoading = false;

        if (currentPage >= totalPages) {
          observer.disconnect();
          container.remove();
        }
      })
      .catch(function (err) {
        console.error('Infinite scroll error:', err);
        loading.style.display = 'none';
        isLoading = false;
      });
  }
})();
